export const applyFilters = ({ filters, type, value, attribute = null, callback }) => {
  let newFilters = {};

  switch (type) {
    case 'attribute':
      let newAttributeArray;

      const { attributes = [] } = filters;

      const attributeInFilters = attributes.some(
        (filterAttribute) => filterAttribute.slug === attribute.node.slug
      );

      if (attributeInFilters) {
        newAttributeArray = attributes
          .map((filterAttribute) => {
            if (filterAttribute.slug === attribute.node.slug) {
              return value.id === 0
                ? null
                : {
                    ...filterAttribute,
                    values: [value.id]
                  };
            }

            return filterAttribute;
          })
          .filter((filterAttribute) => filterAttribute !== null);
      } else {
        newAttributeArray = [
          ...attributes,
          {
            slug: attribute.node.slug,
            values: [value.id]
          }
        ];
      }

      newFilters = {
        ...filters,
        attributes: newAttributeArray
      };

      break;

    case 'category':
      newFilters = {
        ...filters,
        categories: [value.id]
      };
      break;

    case 'search':
      newFilters = {
        ...filters,
        search: value
      };
      break;

    default:
      break;
  }

  callback(newFilters);
};
